const homeTopSlides = {
  slides: [{
    caption: 'For everyone who has ever dreamed of getting away from it all',
    link: '/specials/',
    img: '//cdn.sandals.com/beaches/v12/images/general/destinations/turks/top-slides/girl-and-beach.jpg'
  },
  {
    caption: 'Discover Paradise with Local Adventure Tours',
    link: '/specials/',
    img: '//cdn.sandals.com/beaches/v12/images/general/destinations/turks/top-slides/islands.jpg'
  },
  {
    caption: 'Grace Bay - Voted the World&prime;s #1 Best Beach by TripAdvisor&prime;s Travelers&prime; Choice awards.',
    link: '/liv-plus/real-madrid-clinic/',
    img: '//cdn.sandals.com/beaches/v12/images/general/destinations/turks/top-slides/diving.jpg'
  }]
};

module.exports = homeTopSlides;
